<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат In-Read Video</div>
    <div class="markup__h markup__h_3">
      Данное размещение содержит - лого и текст перед роликом, кнопку внутри плеера для перехода.
    </div>

    <br>
    <div class="markup__h markup__h_orange"><strong>Демо формата:</strong></div>
    <ul class="markup__ul markup__ul_small">
      <li><router-link to="/mobile/mobileNativeVideo" target="_blank" class="link">Mobile</router-link></li>
      <li v-if="!isMobile"><router-link to="/desktop/inReadVideoStandart" target="_blank" class="link">Desktop</router-link></li>
    </ul>
    <br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Видеоролик:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: MP4</li>
          <li>Видеокодек: H.264</li>
          <li>Аудиокодек: MP3 или AAC</li>
          <li>Разрешение: рекомендуется не ниже Full HD 1080p</li>
          <li>Частота кадров: 30 в секунду</li>
          <li>Соотношение сторон: естественное, без добавления черного поля сверху и снизу (например, 16:9)</li>
          <li>Вес: ограничений нет, но рекомендуется
            <ul class="markup__ul markup__ul_nested">
              <li>desktop: до 5 МБ</li>
              <li>mobile: до 3 МБ</li>
            </ul>
          </li>
          <li>
            Хронометраж:
            <ul class="markup__ul markup__ul_nested">
              <li>оптимальный: 10-15 секунд</li>
              <li>максимальный: 30 секунд</li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Логотип:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PNG</li>
          <li>Прозрачный фон</li>
          <li>Соотношение сторон: рекомендуется 1:1</li>
          <li>Размеры: рекомендуется ширина 200px</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Текст (с учетом пробелов):</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Заголовок: до 50 символов</li>
          <li>Описание: до 75 символов</li>
          <li>Для мобильного размещения не рекомендуется использовать описание</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Кнопка:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Текст: до 15 символов</li>
          <li>Положение:
            <ul class="markup__ul markup__ul_nested">
              <li>desktop: местоположение кнопки может варьироваться: она может быть снизу/слева/cправа или сверху</li>
              <li>mobile: под видеороликом</li>
            </ul>
          </li>
          <li>
            Внешний вид: дефолтный или кастомизированный. Есть возможность изменить внешний вид, использовав готовый дизайн клиента (необходимо предоставить готовую кнопоку в PNG или макеты PSD / FIGMA / AI), либо мы можем подготовить дизайн кнопки самостоятельно.
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Пэкшот (опционально):</strong>
          <p>Для установки пэкшота (заглушки) в конце ролика - потребуется изображение:</p>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PSD / FIGMA / AI / PNG</li>
          <li>Cоотношение сторон: такое же как и у видео-файла (например, 16:9)</li>
          <li>Размеры: ширина не меньше 1000px</li>
        </ul>
      </li>
    </ul>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'inreadVideo',
  components: {
    markedZoneAtention,
  },
  data() {
    return {
      isMobile,
    };
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
